<form [formGroup]="form">
	<app-stride-log-student-field
		[fg]="form"
		formGroupOrControlName="studentUuid"
		label="Student"
		[clientUuid]="clientUuid()"
		(onChange)="onChange()"
	></app-stride-log-student-field>
</form>
